import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=3fa0828c&scoped=true&"
import script from "./IconPicker.vue?vue&type=script&lang=ts&"
export * from "./IconPicker.vue?vue&type=script&lang=ts&"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=3fa0828c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa0828c",
  null
  
)

export default component.exports